import React from 'react';
import "./MedicineMaster.css";

// Css Written in medicine master file


const ViewMedicine = (props) => {
    // console.log(props, "mypropsmedicine")
    return (
        <>
            <div className="medicineHead">
                <div className>
                    <span className="medicineTitle"
                        style={{
                            textAlign: (localStorage.pharmacy_language == 'ar' ? 'right' : '')
                        }}
                    >{props.t("medicine_name")}</span>
                    <span className="medicineDetail">{props.viewMedicineData.medicine_name}</span>
                </div>
                <div className>
                    <span className="medicineTitle">{props.t("unit_rate_with_kwd")} <span style={{ fontSize: '10px' }}>({props.t("kwd")})</span></span>
                    <span className="medicineDetail">{props.viewMedicineData.unit_rate}</span>
                </div>
                <div className>
                    {/* <span className="medicineTitle">Incentive (%)</span> */}
                    <span className="medicineTitle">{props.t("incentive_percentage")}</span>
                    <span className="medicineDetail">{props.viewMedicineData.commission_percentage}</span>
                </div>
            </div>
        </>
    )
}

export default ViewMedicine;
